var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sourceLanguage !== _vm.targetLanguage)?_c('span',[_vm._v("   "),_c('a',{staticClass:"translate",attrs:{"href":_vm.url,"target":"google_translate"}},[_vm._v(_vm._s(_vm.$t('translate')))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }